import React, {useState} from 'react';
import { authUrl } from '../../config';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Login = (props) => {
    const [email,setEmail] = useState('')
    const navigate = useNavigate();

    const getcode = async() =>{
        axios.post(`${authUrl}/auth/loginwithemail`,{email:email}).then(res=>{
            console.log('the res is',res)
            navigate('/code',{state:{email:email}})
        }).catch(error=>{
          })
    }

    return (
        <div style={{
            display:'flex',
            flexDirection:'column',
            width:'100%',
            height:'100vh',
            justifyContent:'center',
            alignItems:'center'
        }}>
            <div style={{
                width:'200px',
                display:'flex',
                flexDirection:'column'
            }}>
            <input
                value={email}
                placeholder="email..."
                onChange={(e)=>{
                    setEmail(e.target.value)
                }}
            />
            <button onClick={getcode}>get code</button>
            </div>
        </div>
    )
}

export default Login;
